import ConfirmModal from '../../components/ConfirmModal'
import { DELETE_POPUP_FRAME } from './templates/DeleteConfirmModal'

// "Delete scenario?" -- Figma frame delete-confirmation-popup. Its geometry, fill and button colour
// are the template delete popup's (same frame name, same drawn shell); README.md ("Delete asks
// first") says why they are reused rather than re-measured. One centred Delete, no Cancel, as drawn.
export default function DeleteScenarioModal({ open, onConfirm, onClose }) {
  // Escape is ConfirmModal's own now (useDialogFocus); a second listener here would close twice.
  return (
    <ConfirmModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Delete scenario?"
      body="Are you sure you want to delete? This can’t be undone."
      confirmLabel="Delete"
      confirmClassName="bg-[#D85263] hover:bg-[#E86575]"
      width={364}
      panelBg="#F4FAEF"
      frame={DELETE_POPUP_FRAME}
    />
  )
}
